import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { useSiteLang, TRANSLATED_PATHS } from '@/components/site/SiteLang';
import QualificationFormModal from '@/components/QualificationForm';

/* Pie único de la web pública (mismo en todas las páginas). Vive en PublicLayout. */
const T = {
  es: {
    about: 'Freedom Homes Club es un club privado operado por Freedom Life Club LLC: acceso a oportunidades inmobiliarias, formación, comunidad y eventos.',
    club: 'El club', legal: 'Legal', platform: 'Plataforma',
    how: 'Cómo funciona', memberships: 'Membresías', bootcamp: 'Bootcamp', events: 'Eventos', contact: 'Contacto',
    terms: 'Términos y condiciones', privacy: 'Política de privacidad', login: 'Iniciar sesión', test: 'Test de idoneidad',
  },
  en: {
    about: 'Freedom Homes Club is a private club operated by Freedom Life Club LLC: access to real estate opportunities, training, community and events.',
    club: 'The club', legal: 'Legal', platform: 'Platform',
    how: 'How it works', memberships: 'Memberships', bootcamp: 'Bootcamp', events: 'Events', contact: 'Contact',
    terms: 'Terms & Conditions', privacy: 'Privacy Policy', login: 'Sign in', test: 'Suitability test',
  },
};

const linkCls = 'text-sm text-white/50 hover:text-[#c9a84c] transition-colors py-1';

export default function MainFooter() {
  const { pathname } = useLocation();
  const { lang } = useSiteLang();
  const siteLang = TRANSLATED_PATHS.includes(pathname) ? lang : 'es';
  const t = T[siteLang];
  const [testOpen, setTestOpen] = useState(false);
  return (
    <footer className="bg-[#0a1628] border-t border-white/10 pt-16 pb-24 md:pb-12" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10 mb-12">
          <div className="col-span-2 lg:col-span-1">
            <Link to="/"><img src="/logo-fhc-sm.png" alt="Freedom Homes Club" className="h-[72px] w-auto mb-3" /></Link>
            <p className="text-sm text-white/40 max-w-sm leading-relaxed">{t.about}</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-[#c9a84c] mb-4">{t.club}</p>
            <div className="flex flex-col gap-2">
              <Link to="/como-funciona" className={linkCls}>{t.how}</Link>
              <Link to="/membresias" className={linkCls}>{t.memberships}</Link>
              <Link to="/bootcamp-tokenizacion" className={linkCls}>{t.bootcamp}</Link>
              <Link to="/eventos" className={linkCls}>{t.events}</Link>
              <Link to="/contacto" className={linkCls}>{t.contact}</Link>
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-[#c9a84c] mb-4">{t.legal}</p>
            <div className="flex flex-col gap-2">
              <Link to="/terms-conditions" className={linkCls}>{t.terms}</Link>
              <Link to="/privacy-policy-fhc" className={linkCls}>{t.privacy}</Link>
            </div>
            <p className="text-xs uppercase tracking-widest text-[#c9a84c] mb-4 mt-8">{t.platform}</p>
            <div className="flex flex-col gap-2">
              <Link to="/dashboard/login" className={`${linkCls} flex items-center gap-1.5`} data-testid="footer-login"><LogIn size={13} /> {t.login}</Link>
              {/* Sin alta directa desde la web pública: se entra por el test de idoneidad */}
              <button type="button" onClick={() => setTestOpen(true)} className={`${linkCls} text-left`} data-testid="footer-test">{t.test}</button>
            </div>
          </div>
          <div className="col-span-2 lg:col-span-1 min-w-0">
            <p className="text-xs uppercase tracking-widest text-[#c9a84c] mb-4">{t.contact}</p>
            <div className="flex flex-col gap-2 text-sm text-white/50 break-words">
              <a href="mailto:info@freedomhomes.club" className="hover:text-[#c9a84c] transition-colors py-1">info@freedomhomes.club</a>
              <a href="mailto:soporte@freedomhomes.club" className="hover:text-[#c9a84c] transition-colors py-1">soporte@freedomhomes.club</a>
              <p className="py-1 leading-relaxed">407 Lincoln Rd Ste 12-N<br />Miami Beach, FL 33139</p>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-[#c9a84c]/15">
          <p className="text-xs text-white/30">© {new Date().getFullYear()} Freedom Life Club LLC</p>
        </div>
      </div>
      <QualificationFormModal isOpen={testOpen} onClose={() => setTestOpen(false)} source="footer" lang={siteLang} />
    </footer>
  );
}
